export const ROLE_ADMIN = 0;
export const ROLE_DENTIST = 1;
export const ROLE_LAB = 2;
export const ROLE_DENTIST_LIMITED = 4;
export const ROLE_SPECIALIST = 5;
export const ROLE_DENTIST_MOBILE = 6;
export const ROLE_LAB_MOBILE = 7;
export const ROLE_DENTIST_MOBILE_PREMIUM = 8;
export const ROLE_LAB_MOBILE_CASE_FREE = 9;
